import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
import { buyerPhoneSchema } from '../_shared/phone.js';
const fidelityCardSchema = z.object({
    companyName: z.string().min(1),
    cardNumber: z.string().min(1),
});
const identityDocumentSchema = z.object({
    documentNumber: z.string().min(1),
    expiryDate: isoDateString(),
    issuingCountry: z.string().min(1),
    type: z.enum(['PASSPORT', 'CNI']),
});
export const submitPassengerSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    birthDate: z.string().min(1),
    fidelityCard: fidelityCardSchema.optional(),
    gender: z.enum(['MALE', 'FEMALE']),
    identityDocument: identityDocumentSchema.optional(),
    nationality: z.string().length(3),
    type: z.enum(['Adult', 'Child', 'Infant']),
});
export const submitPassengersSchema = z.object({
    buyerEmail: z.string().email(),
    buyerPhone: buyerPhoneSchema,
    passengers: z.array(submitPassengerSchema),
});
